/* eslint new-cap: 0 */
/* global PSSessions, analyticsIntegrations */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import clickOutside from 'react-onclickoutside';
import { FormattedMessage } from 'react-intl';

class ActivityDropdownInternal extends React.Component {
  constructor (props) {
    super(props);

    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.optionList = this.optionList.bind(this);
    this.highlightText = this.highlightText.bind(this);
    this.removeHovered = this.removeHovered.bind(this);
    this.renderDropOptions = this.renderDropOptions.bind(this);
  }

  handleClickOutside (e) {
    const { clickOutsideClass } = this.props;
    const ignoreClickOutside = $(e.target).hasClass(clickOutsideClass || 'ignore-clickoutside');
    if (this.props.enableClickOutside && !ignoreClickOutside) {
      this.props.closeDropdown();
      if (this.props.suggestions) {
        if (!$('#act-list-0 a').hasClass('hovered')) {
          $('#act-list-0 a').addClass('hovered');
        }
      }
    }
  }

  optionList (props) {
    const { hideSeeMoreActivity } = this.props;
    return (
      <li role="presentation"
        key={`activity-list-${props.index}`}
        id={`act-list-${props.index}`}
        role="presentation"
        data-name={props.name}
        data-id={props.id}
        className= "border-bottom searchbar-metro-option"
        onClick={props.clickFn}
        tabIndex="-1"
        onFocus={this.removeHovered}
      >
        { props.miscList ?
          <div className="more-cities">
            <div className="row">
              <div className="row-height">
                <div className="col-xs-9 col-height col-middle ellipsis">
                  <a href="#" onClick={this.props.seeMoreAction}>
                    <FormattedMessage
                      id="boards.activity_dropdown_internal.popular_activities"
                      defaultMessage="See all popular activities"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
          : <a href="#" className={`${props.hovered}`}>
            <div className="row">
              <div className="row-height">
                <div className="col-xs-9 col-height col-middle">
                  {props.highlighted_name}
                </div>
              </div>
            </div>
          </a> }
      </li>
    );
  }

  highlightText (matchedSubstring, description) {
    const strings = matchedSubstring.toLowerCase().split(' ');
    const drop = description.dropdown;
    const word = drop.toLowerCase();
    const wordLength = drop.length;
    const matches = [];
    _.each(strings, (str) => {
      const index = word.indexOf(str);
      if (-1 !== index) {
        matches.push({
          index,
          length: str.length
        });
      }
    });

    const orderedMatches = _.sortBy(matches, 'index');
    // starting point is 0
    let start = 0;
    // for each match, take the index
    const renderDropString = () => {
      return _.map(orderedMatches, (match) => {
        const { index, length } = match;
        if (!length || start > index) {
          return;
        }
        let normal;
        // if the index - starting point is greater than 0,
        const charsBefore = index - start;
        if (0 < charsBefore) {
          // create a substring from startingpoint to startingPoint + index;
          normal = drop.substr(start, charsBefore);
        }
        // take substring from index through length and make bold
        const bold = drop.substr(index, length);
        // new starting point is next index
        start = index + length;
        return (
          <span key={`drop-${index}`}>
            <span className="text-gray">{normal}</span><span className="bold">{bold}</span>
          </span>
        );
      });
    };
    // if after look the starting point is < length + 1, make another regular string
    return (
      <div className="ellipsis">
        { renderDropString() }
        { start < wordLength ?
          <span className="text-gray">{drop.substring(start)}</span>
          :
          null
        }
      </div>
    );
  }

  removeHovered () {
    $('#act-list-0 a').removeClass('hovered');
  }

  renderDropOptions (props) {
    let optionsArray = [];
    const { defaults, suggestions, clickFn, activityValue, hideSeeMoreActivity } = props;
    if (suggestions && suggestions.length) {
      optionsArray = suggestions.map((suggestion, i) => {
        let hovered;
        if (0 === i) {
          hovered = 'hovered';
        }
        return {
          hovered: hovered || '',
          highlighted_name: this.highlightText(activityValue, suggestion),
          active: true,
          name: suggestion.dropdown,
          id: suggestion.id,
          usetype: suggestion.space_use,
          subtype: suggestion.use_subtype
        };
      });
      if (!hideSeeMoreActivity) {
        optionsArray.push({ miscList: true });
      }
    } else {
      optionsArray = _.map(defaults, (suggestion) => {
        return {
          name: suggestion.dropdown,
          id: suggestion.id,
          usetype: suggestion.space_use,
          subtype: suggestion.use_subtype
        };
      });
      if (!hideSeeMoreActivity) {
        optionsArray.push({ miscList: true });
      }
    }
    return optionsArray.map((option, i) => {
      const optionProps = option;
      optionProps.highlighted_name = option.highlighted_name || option.name;
      optionProps.clickFn = option.miscList ? null : clickFn;
      optionProps.index = i;
      return this.optionList(optionProps);
    });
  }

  render () {
    return (
      <ul role="menu" aria-expanded="false" onMouseEnter={this.removeHovered} className="dropdown-menu city-dropdown">
        {this.renderDropOptions(this.props)}
      </ul>
    );
  }
}

ActivityDropdownInternal.propTypes = {
  suggestions: PropTypes.array,
  defaults: PropTypes.array,
  clickFn: PropTypes.func,
  seeMoreAction: PropTypes.func,
  activityValue: PropTypes.string,
  enableClickOutside: PropTypes.bool,
  closeDropdown: PropTypes.func,
  origin: PropTypes.string,
  hideSeeMoreActivity: PropTypes.bool
};

export const ActivityDropdown = clickOutside(ActivityDropdownInternal);
